export default __webpack_public_path__ + "static/media/policy.9b640a97.pdf";